<template>
	<div>

		<v-navigation-drawer v-model="drawer" color="blue-grey darken-4" dark app>
			<v-list-item >
				
					<v-list-item-title class="title">
						<!-- <v-icon left>fal fa-chalkboard-teacher</v-icon>  -->
						<v-avatar size="36px">
							<img src="./../assets/img/logo-sem-escrita.svg" alt="CETABA">
						</v-avatar>
						<v-divider class="mx-2" vertical></v-divider>
						Gerenciador
					</v-list-item-title>
				
			</v-list-item>

			<v-list v-if="!hideMenu">
				<!-- <v-list-item :to="{ name: 'home', params: { id: 1 }, query: { id: true } }"> -->
				<v-list-item :to="{ name: 'Home' }">
					<v-list-item-action>
						<v-icon dense>fal fa-home</v-icon>
					</v-list-item-action>
					<v-list-item-title>Home</v-list-item-title>
				</v-list-item>

				<v-divider></v-divider>

				<v-list-item @click="changeHideMenu('Pessoas')" :to="{ name:'Pessoas' }">
					<v-list-item-action>
						<v-icon dense>fal fa-user</v-icon>
					</v-list-item-action>
					<v-list-item-title>Pessoas</v-list-item-title>
					<v-list-item-icon>
						<v-icon dense>fal fa-angle-right</v-icon>
					</v-list-item-icon>
				</v-list-item>
				<v-list-item @click="changeHideMenu('Empresas')" :to="{ name:'Empresas' }">
					<v-list-item-action>
						<v-icon dense>fal fa-industry-alt</v-icon>
					</v-list-item-action>
					<v-list-item-title>Empresas</v-list-item-title>
					<v-list-item-icon>
						<v-icon dense>fal fa-angle-right</v-icon>
					</v-list-item-icon>
				</v-list-item>
				<v-list-item @click="changeHideMenu('Cursos')" :to="{ name:'Cursos' }">
					<v-list-item-action>
						<v-icon dense>fal fa-graduation-cap</v-icon>
					</v-list-item-action>
					<v-list-item-title>Cursos</v-list-item-title>
					<v-list-item-icon>
						<v-icon dense>fal fa-angle-right</v-icon>
					</v-list-item-icon>
				</v-list-item>
				<v-list-item @click="changeHideMenu('Relatorios')" :to="{ name:'Relatorios' }">
					<v-list-item-action>
						<v-icon dense>fal fa-th-list</v-icon>
					</v-list-item-action>
					<v-list-item-title>Relatórios</v-list-item-title>
					<v-list-item-icon>
						<v-icon dense>fal fa-angle-right</v-icon>
					</v-list-item-icon>
				</v-list-item>

				<v-divider></v-divider>
				<v-subheader>Rotas externas</v-subheader>
				<v-list-item @click="changeHideMenu('Cadastro')" :to="{ name:'Cadastro' }">
					<v-list-item-action>
						<v-icon dense>fal fa-pen</v-icon>
					</v-list-item-action>
					<v-list-item-title>Cadastro externo</v-list-item-title>
					<v-list-item-icon>
						<v-icon dense>fal fa-angle-right</v-icon>
					</v-list-item-icon>
				</v-list-item>

				<v-divider></v-divider>

				<v-list-item :to="{ name: 'Admins' }">
					<v-list-item-action>
						<v-icon dense>fal fa-users-cog</v-icon>
					</v-list-item-action>
					<v-list-item-title>Admins</v-list-item-title>
				</v-list-item>

			</v-list>
			

			<v-list v-if="!hideMenu&&showMolinum">
				<v-divider></v-divider>
				<v-subheader>Molinum</v-subheader>

				<v-list-item @click="changeHideMenu('peca')" :to="{ name:'Peca' }">
					<v-list-item-action>
						<v-icon dense>fal fa-puzzle-piece</v-icon>
					</v-list-item-action>
					<v-list-item-title>Peça</v-list-item-title>
					<v-list-item-icon>
						<v-icon dense>fal fa-angle-right</v-icon>
					</v-list-item-icon>
				</v-list-item>
				<v-list-item @click="changeHideMenu('maquina')" :to="{ name: 'Maquina' }">
					<v-list-item-action>
						<v-icon dense>fal fa-charging-station</v-icon>
					</v-list-item-action>
					<v-list-item-title>Máquina</v-list-item-title>
					<v-list-item-icon>
						<v-icon dense>fal fa-angle-right</v-icon>
					</v-list-item-icon>
				</v-list-item>
				<v-list-item :to="{ name: 'Distribuidoras' }">
					<v-list-item-action><v-icon dense>fal fa-truck</v-icon></v-list-item-action>
					<v-list-item-title>Distribuidoras</v-list-item-title>
				</v-list-item>

			</v-list>

			<v-list v-if="Pessoas">
				<v-list-item @click="changeHideMenu('Pessoas')">
					<v-list-item-action><v-icon color="blue">fal fa-arrow-left</v-icon></v-list-item-action>
					<v-list-item-title>Voltar</v-list-item-title>
				</v-list-item>
				<v-divider></v-divider>
				<v-list-item :to="{ name: 'PessoasList' }">
					<v-list-item-title>Pessoas</v-list-item-title>
				</v-list-item>
			</v-list>

			<v-list v-if="Empresas">
				<v-list-item @click="changeHideMenu('Empresas')">
					<v-list-item-action><v-icon color="blue">fal fa-arrow-left</v-icon></v-list-item-action>
					<v-list-item-title>Voltar</v-list-item-title>
				</v-list-item>
				<v-divider></v-divider>
				<v-list-item :to="{ name: 'EmpresasList' }">
					<v-list-item-title>Empresas</v-list-item-title>
				</v-list-item>
				<v-list-item :to="{ name: 'CargosList' }">
					<v-list-item-title>Cargos</v-list-item-title>
				</v-list-item>
			</v-list>

			<v-list v-if="Cursos">
				<v-list-item @click="changeHideMenu('Cursos')">
					<v-list-item-action><v-icon color="blue">fal fa-arrow-left</v-icon></v-list-item-action>
					<v-list-item-title>Voltar</v-list-item-title>
				</v-list-item>
				<v-divider></v-divider>
				<v-list-item :to="{ name: 'CursosList' }">
					<v-list-item-title>Cursos</v-list-item-title>
				</v-list-item>
			</v-list>

			<v-list v-if="Relatorios">
				<v-list-item @click="changeHideMenu('Relatorios')">
					<v-list-item-action><v-icon color="blue">fal fa-arrow-left</v-icon></v-list-item-action>
					<v-list-item-title>Voltar</v-list-item-title>
				</v-list-item>
				<v-divider></v-divider>
				<v-list-item :to="{ name: 'PessoasByEmpresa' }">
					<v-list-item-title>Pessoas By Empresa</v-list-item-title>
				</v-list-item>
				<v-list-item :to="{ name: 'EmailByPessoas' }">
					<v-list-item-title>Email By Pessoas</v-list-item-title>
				</v-list-item>
				<v-list-item :to="{ name: 'SujestaoEmpresas' }">
					<v-list-item-title>Sujestão empresa e cargo</v-list-item-title>
				</v-list-item>
			</v-list>

			<v-list v-if="Cadastro">
				<v-list-item @click="changeHideMenu('Cadastro')">
					<v-list-item-action><v-icon color="blue">fal fa-arrow-left</v-icon></v-list-item-action>
					<v-list-item-title>Voltar</v-list-item-title>
				</v-list-item>
				<v-divider></v-divider>
				<v-list-item :to="{ name: 'CadastroUser' }">
					<v-list-item-title>User</v-list-item-title>
				</v-list-item>
				<v-list-item :to="{ name: 'CadastroEmpresa' }">
					<v-list-item-title>Empresa</v-list-item-title>
				</v-list-item>
			</v-list>

			<v-list v-if="peca">
				<v-list-item @click="changeHideMenu('peca')">
					<v-list-item-action><v-icon color="blue">fal fa-arrow-left</v-icon></v-list-item-action>
					<v-list-item-title>Voltar</v-list-item-title>
				</v-list-item>
				<v-divider></v-divider>
				
				<v-list-item :to="{ name: 'PecaPecas' }">
					<v-list-item-title>Peças</v-list-item-title>
				</v-list-item>
				<v-list-item :to="{ name: 'PecaMarcas' }">
					<v-list-item-title>Marcas</v-list-item-title>
				</v-list-item>
				<v-list-item :to="{ name: 'PecaTipos' }">
					<v-list-item-title>Tipos</v-list-item-title>
				</v-list-item>
				<v-list-item :to="{ name: 'PecaPecasMarcaTipo' }">
					<v-list-item-title>Peças com marca e tipo</v-list-item-title>
				</v-list-item>
			</v-list>

			<v-list v-if="maquina">
				<v-list-item @click="changeHideMenu('maquina')">
					<v-list-item-action><v-icon color="blue">fal fa-arrow-left</v-icon></v-list-item-action>
					<v-list-item-title>Voltar</v-list-item-title>
				</v-list-item>
				<v-divider></v-divider>

				<v-list-item :to="{ name: 'MaquinaMaquinas' }">
					<v-list-item-title>Máquinas</v-list-item-title>
				</v-list-item>
				<v-list-item :to="{ name: 'MaquinaMarcas' }">
					<v-list-item-title>Marcas</v-list-item-title>
				</v-list-item>
				<v-list-item :to="{ name: 'MaquinaModelos' }">
					<v-list-item-title>Modelos</v-list-item-title>
				</v-list-item>
				<v-list-item :to="{ name: 'MaquinaMaquinasMarcaModelo' }">
					<v-list-item-title>Máquinas com marca e modelo</v-list-item-title>
				</v-list-item>
			</v-list>

			<template v-slot:append>
				<div class="pa-2" @click="logout">
					<v-btn block color="blue darken-1"><v-icon left>fal fa-sign-out-alt</v-icon>Sair</v-btn>
				</div>
			</template>
		</v-navigation-drawer>

		<v-app-bar app color="blue darken-3" dark dense>
			<v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
			<v-toolbar-title>Olá {{ user.nome }}</v-toolbar-title>

		</v-app-bar>

	</div>
</template>

<script>
import { mapState } from 'vuex'

import idb from '@/api/idb'

export default {
	data () {
		return {
			showMolinum: false,
			drawer: null,
			collapseOnScroll: true,
			hideMenu: false,
			Pessoas: false,
			Empresas: false,
			Cursos: false,
			Relatorios: false,
			Cadastro: false,
			peca: false,
			maquina: false
		}
	},
	computed: {
		...mapState([
			'user',
			'XMLHttpRequest',
		]),
	},
	methods:{
		logout() {
			let formData = new FormData()
			formData.append('user_id', this.user.id)
			formData.append('token', this.user.token)
			let vd = this
			this.$axiosPost.post('logout.php', formData)
			.then(function(response){
				if(response.data['error']===0){
					idb.clearObject(['user'])
					vd.$store.dispatch('logOut', { destination: 'Home' })
				}else{
					vd.$store.dispatch('alert', {
						alertMessage: response.data['alertMessage'],
						alertType: response.data['alertType'],
					})
				}
			})
			.catch(function(response){
				vd.$store.dispatch('XMLHttpRequest', { value: false })
				console.log('ERROR!! '+response)
			})
		},
		changeHideMenu(menu){
			if(menu=='Pessoas'){ this.Pessoas = !this.Pessoas }
			if(menu=='Empresas'){ this.Empresas = !this.Empresas }
			if(menu=='Cursos'){ this.Cursos = !this.Cursos }
			if(menu=='Relatorios'){ this.Relatorios = !this.Relatorios }
			if(menu=='Cadastro'){ this.Cadastro = !this.Cadastro }

			if(menu=='peca'){ this.peca = !this.peca }
			if(menu=='maquina'){ this.maquina = !this.maquina }
			this.hideMenu = !this.hideMenu
		}
	}
}
</script>